import React from 'react';

import { SearchBibsRowConfigShape } from 'app/shapes/browse';
import { BibsRowBibs } from 'app/components/browse/shared/BibsRowBibs';

const SearchBibsRow = ({ config }) => {
  const { displayBibs, hasHistoryRoutingForTitles, title, titleUrl, trackBibClick, trackTitleClick } = config;

  return (
    <div className="cp-bibs-row">
      <BibsRowBibs
        displayBibs={displayBibs}
        hasHistoryRoutingForTitles={hasHistoryRoutingForTitles}
        title={title}
        titleUrl={titleUrl}
        trackBibClick={trackBibClick}
        trackTitleClick={trackTitleClick}
      />
    </div>
  );
};

SearchBibsRow.propTypes = {
  config: SearchBibsRowConfigShape.isRequired
};

export default SearchBibsRow;
